import { App } from "App";
import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import { initGA, logPageView } from "./analytics";
import "./i18n";

const root = ReactDOM.createRoot(
	document.getElementById("root") as HTMLElement
);

initGA();
logPageView(window.location.pathname);

root.render(
	<React.StrictMode>
		<HelmetProvider>
			<App />
		</HelmetProvider>
	</React.StrictMode>
);
